<div class="pos-fix vh-center">
    <loading></loading>
</div>